<template>
  <div class="container-header" style="margin-bottom: 20px;">
    <b-row>
      <b-col md="6" lg="6">
        <b-form onsubmit="return false">
          <b-input-group>
            <b-form-input @keyup.enter="query" type="search" v-model="form.resName" placeholder="Search here..." />
            <b-input-group-append>
              <b-button-group>
                <b-button variant="primary" class="my-2 my-sm-0" @click="query">
                  <i class="fa fa-search"></i>
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        resName: '',
        resNameEn: '',
        resStatus: ['Y']
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  },
  mounted () {
    this.$emit('reset')
    this.query()
  },
  activated() {
    this.query()
  }
}
</script>
